import React, { useState, useEffect } from 'react'
import './OurProducts.scss'
import { Link } from 'react-router-dom'

import 'aos/dist/aos.css'
import Aos from 'aos'

import { useNavigate } from 'react-router-dom'

import LazyLoad from 'react-lazy-load'

export default function OurProducts() {
  const [text, setText] = useState(false)

  const navigation = useNavigate()

  const ourProductHandler = () => {
    setText(true)
  }

  useEffect(() => {
    Aos.init({ duration: 2500, once: true })
  }, [])

  return (
    <div className='ourProducts' data-aos= 'fade-right'>
      <LazyLoad height={500} offset={300}>
        <div className="ourProducts_image">
        </div>
      </LazyLoad>
      <div className='container'>
        <div className='row'>
          <div className="ourProducts_contents">
            <div className="ourProducts_contents_title">
              OUR PRODUCTS
            </div>
            <div className="ourProducts_contents_subtitle">
              <div style={text ? { display: 'none' } : { display: '' }}>
                Global Energy Investment and his partner’s leading companies operate in the sector of Steel Industrial, Construction, MSW plant,
                recycling and waste to power plant.<br /><Link onClick={ourProductHandler}>read more ...</Link>
              </div>
              <div style={text ? { display: '' } : { display: 'none' }}>
                Global Energy Investment and his partner’s leading companies operate in the sector of Steel Industrial, Construction, MSW plant,
                recycling and waste to power plant.<br />
                The production facility includes two hot rolling lines with the total capacity of about 1/2 million ton per year.<br />
                The present product portfolio comprises of a range of quality steel grades and sizes (5.5- 40 mm) in the form of plain
                and ribbed wire rod and bar used in complex industrial applications such as automotive, energy, mechanical engineering
                as well as construction.
              </div>
            </div>
            <div className='buttonsEn'>
              <div className='row_buttons'>
                <div className='button'>
                  <div className='contents' onClick={() => navigation('/wirerod')}>
                    <div className='buttons_img'>  
                    </div>
                    <hr />
                    <div className='buttons_title'>
                      WIRE ROD
                    </div>
                  </div>
                </div>

                <div className='button2'>
                  <div className='contents' onClick={() => navigation('/steelrebar')}>
                    <div className='buttons_img'>  
                    </div>
                    <hr />
                    <div className='buttons_title'>
                      STEEL REBAR
                    </div>
                  </div>
                </div>
              </div>

              <div className='row_buttons'>
                <div className='button3'>
                  <div className='contents' onClick={() => navigation('/standardgalvanizedwire')}>
                    <div className='buttons_img'>  
                    </div>
                    <hr />
                    <div className='buttons_title'>
                      STANDARD GALVANIZED<br />
                      WIRE
                    </div>
                  </div>
                </div>

                <div className='button4'>
                  <div className='contents' onClick={() => navigation('/steelingot')}>
                    <div className='buttons_img'>  
                    </div>
                    <hr />
                    <div className='buttons_title'>
                      STEELL INGOT ( BILLET )
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
